import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getLabOrders ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/laborders/_filter?pageSize=' + (options.pageSize || 3) + '&pageNumber=' + options.pageNumber, options.query)).data
      return response
    },
    async getLabOrderById ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/laborders/' + options.id)).data
      return response
    },
    async getLabTestById ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/labtests/' + options.id)).data
      return response
    },
    async searchLabtests ({ }, options) {
      //Sending labname as query param for filtering based on billing details for laborder creation
      let url = options.lab ? (this.state.baseUrl + '/labtests/search?limit=5&query=' + options.searchText + '&lab=' + options.lab) : (this.state.baseUrl + '/labtests/search?limit=5&query=' + options.searchText)
      let response = (await Vue.http.get(url)).data
      return response
    },
    async createLabOrder ({ }, laborder) {
      let response = (await Vue.http.post(this.state.baseUrl + '/laborders/', laborder)).data
      return response
    },
    async updateLabOrderStatus ({ }, options) {
      let response = (await Vue.http.put(this.state.baseUrl + '/laborders/update/status/' + options.laborderId, { status: options.status })).data
      return response
    },
    async acceptlabOrder ({ }, options) {
      let response = (await Vue.http.put(this.state.baseUrl + '/laborders/accept/' + options.laborderId)).data
      return response
    },
    async getLabOrderByBookingRequestId ({ }, options) {
      try {
        let response = (await Vue.http.get(this.state.baseUrl + '/laborder/bybookingrequestid/' + options.requestId)).data
        return response
      } catch {
        return null
      }
    },
    async getLabordersByPatient ({ }, options) {
      try {
        let response = (await Vue.http.get(this.state.baseUrl + '/laborder/bypatient/' + options.patientId)).data.data
        return response
      } catch {
        return null
      }
    },
    async getLaborderStats ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/laborders/stats', options)).data
      return response
    },
    async getFilteredLaborders ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/laborders/_filter', options)).data
      return response
    },
  }
}
